import { render, staticRenderFns } from "./QuizOption.vue?vue&type=template&id=d0d7ec5c&scoped=true&"
import script from "./QuizOption.vue?vue&type=script&lang=js&"
export * from "./QuizOption.vue?vue&type=script&lang=js&"
import style0 from "./QuizOption.vue?vue&type=style&index=0&id=d0d7ec5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d7ec5c",
  null
  
)

export default component.exports